




















import { defineComponent } from "@vue/composition-api";
import {
  PRIVACY_POLICY,
  COMPANY_SITE,
  REQUEST_FORM
} from "@/constants/external-links";
import { useComponentInstance } from "@/helpers/hooks/useComponentInstance";

export default defineComponent({
  name: "RelatedLinksFooter",
  setup() {
    const root = useComponentInstance()!;
    const currentPath: string = root.$route?.path || "";

    const isCurrentPath = (path: string): boolean => {
      return path === currentPath;
    };

    const currentYear = new Date().getFullYear();
    const copyRight = `ⓒ2009-${currentYear} ONE CAREER Inc.`;

    const contents: { label: string; href: string }[] = [
      {
        label: "利用規約（求人掲載）",
        href: "/terms_of_use_for_job"
      },
      {
        label: "利用規約（採用計画）",
        href: "/terms_of_use_for_plan"
      },
      {
        label: "利用規約（スカウト）",
        href: "/terms_of_use_for_scout"
      },
      {
        label: "利用規約（エージェントスカウト）",
        href: "/terms_of_use_for_agent_scout"
      },
      {
        label: "利用規約（採用代行）",
        href: "/terms_of_outsourcing"
      },
      {
        label: "利用規約（新卒紹介）",
        href: "/terms_of_use_for_agent"
      },
      {
        label: "運営会社",
        href: COMPANY_SITE
      },
      {
        label: "プライバシーポリシー",
        href: PRIVACY_POLICY
      },
      {
        label: "利用者情報の外部送信について",
        href: "/external_data_processors"
      },
      {
        label: "個人情報の取扱い",
        href: "/terms_of_privacy_for_partners"
      },
      {
        label: "お問い合わせ",
        href: REQUEST_FORM
      }
    ];
    return { contents, copyRight, isCurrentPath };
  }
});
